import React, { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Components/Applications/ECommerce/Common/FilterComponent";
import { useSelector, useDispatch } from "react-redux";
import { Container, FormGroup, Input } from "reactstrap";
import SvgIcon from "../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { deleteCustomer } from "../../ReduxToolkit/Reducers/AppReducer";
import { Link } from "react-router-dom";
import {
  getDiscountTierByPoints,
  getVendorSettings,
} from "../../services/helper";
import {
  openView,
  openViewWithParams,
} from "../../ReduxToolkit/Reducers/viewReducer";

export default function CustomersList() {
  const dispatch = useDispatch();
  const [filterText, setFilterText] = useState("");
  const { vendorCustomers } = useSelector((state) => state.app);

  const filteredItems = vendorCustomers.filter((item) => {
    return Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
    );
  });

  const handleDeleteCustomer = async (customer) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--theme-red)",
      cancelButtonColor: "var(--theme-blue)",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        dispatch(deleteCustomer(customer.id));
        toast.success("Customer Deleted");
      } catch (error) {
        console.log(error);
        toast.error("Error Deleting Customer");
      }
    }
  };

  const handlePrintCard = (customer) => {
    const vendor_store_name = getVendorSettings("name");
    const vendor_phone = getVendorSettings("vendor_contact_phone");
    const printWindow = window.open("", "_blank", "width=400,height=300");
    if (!printWindow) {
      toast.error("Popup blocked. Please allow popups to print.");
      return;
    }

    const htmlContent = `
      <html>
        <head>
          <title>Customer ID Card</title>
          <style>
            body { font-family: Arial, sans-serif; text-align: center; padding: 30px; }
            .store { font-size: 14px; margin-bottom: 20px; }
            .customer-name { font-size: 18px; font-weight: bold; margin-bottom: 10px; }
            .barcode { margin-top: 20px; }
            .id-label { font-size: 14px; margin-top: 10px; }
          </style>
        </head>
        <body>
          <div class="store">
            <div><strong>${vendor_store_name}</strong></div>
            <div>${vendor_phone}</div>
          </div>
  
          <div class="customer-name">${customer.first_name} ${customer.last_name}</div>
          <div class="barcode">
            <svg id="barcode"></svg>
          </div>
  
          <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
          <script>
            JsBarcode("#barcode", "${customer.customer_unique_id}", {
              format: "CODE128",
              displayValue: true,
              fontSize: 16,
              width: 2,
              height: 50
            });
            setTimeout(() => window.print(), 500);
          </script>
        </body>
      </html>
    `;

    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  const categoryColumns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      cell: (row) => <p>{row.id}</p>,
    },
    {
      name: "Unique ID",
      selector: (row) => row.customer_unique_id,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="mb-1">{row.customer_unique_id}</p>
          <button
            className="btn btn-sm btn-outline-dark"
            onClick={() => handlePrintCard(row)}
          >
            Print
          </button>
        </div>
      ),
    },
    {
      name: "Name",
      selector: (row) => row.first_name,
      sortable: true,
      cell: (row) => <p>{`${row.first_name} ${row.last_name}`}</p>,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => <p>{row.email}</p>,
    },
    {
      name: "Points",
      selector: (row) => row.customer_points,
      sortable: true,
      cell: (row) => <p>{parseFloat(row.customer_points).toFixed(2)}</p>,
    },
    {
      name: "Tier",
      selector: (row) => row.customer_points,
      sortable: true,
      cell: (row) => {
        const tier = getDiscountTierByPoints(row?.customer_points);
        return tier ? <p>{`${tier.label} (${tier.discount}%)`}</p> : <p>-</p>;
      },
    },
    {
      name: "T-Coins",
      selector: (row) => row.customer_tcoins,
      sortable: true,
      cell: (row) => <p>{parseFloat(row.customer_tcoins).toFixed(2)}</p>,
    },
    {
      name: "Address",
      selector: (row) => row.address,
      sortable: true,
      cell: (row) => <p>{row.address}</p>,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="product-action">
          <Link
            onClick={() =>
              dispatch(
                openViewWithParams({
                  view: "customers_edit",
                  params: { customer_id: row.id },
                })
              )
            }
          >
            <SvgIcon iconId="edit-content" />
          </Link>
          <SvgIcon iconId="trash1" onClick={() => handleDeleteCustomer(row)} />
        </div>
      ),
      sortable: false,
    },
  ];

  return (
    <div className="page-body main-project">
      <Container fluid className="mt-3">
        <div className="list-product list-category">
          <div className="d-flex justify-content-between">
            <FilterComponent
              onFilter={(e) => setFilterText(e.target.value)}
              filterText={filterText}
            />
            <Link
              role="button"
              className="btn btn-primary"
              onClick={() => dispatch(openView("customers_new"))}
            >
              Add New
            </Link>
          </div>
          <DataTable
            className="custom-scrollbar"
            data={filteredItems}
            columns={categoryColumns}
            pagination
          />
        </div>
      </Container>
    </div>
  );
}
